/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanyBranchInfo,
    JsonCompanyBranchInfoFromJSON,
    JsonCompanyBranchInfoFromJSONTyped,
    JsonCompanyBranchInfoToJSON,
} from './JsonCompanyBranchInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonCompanyBranchInfo
 */
export interface ApiResultOfListOfJsonCompanyBranchInfo {
    /**
     * 
     * @type {Array<JsonCompanyBranchInfo>}
     * @memberof ApiResultOfListOfJsonCompanyBranchInfo
     */
    data?: Array<JsonCompanyBranchInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanyBranchInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonCompanyBranchInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanyBranchInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanyBranchInfo
     */
    result?: ApiResultOfListOfJsonCompanyBranchInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonCompanyBranchInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonCompanyBranchInfoFromJSON(json: any): ApiResultOfListOfJsonCompanyBranchInfo {
    return ApiResultOfListOfJsonCompanyBranchInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonCompanyBranchInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonCompanyBranchInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonCompanyBranchInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonCompanyBranchInfoToJSON(value?: ApiResultOfListOfJsonCompanyBranchInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonCompanyBranchInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

